import type { TwnPaletteKeyHintsItemData } from '@/components/molecules/palette/twn-palette-key-hints/TwnPaletteKeyHints.types'

// The footer every palette shows unless its caller passes its own `hints`.
const PALETTE_DEFAULT_HINTS = [
  { keys: ['↑', '↓'], label: 'Navigate' },
  { keys: ['↵'], label: 'Select' }
] as const satisfies readonly TwnPaletteKeyHintsItemData[]

export { PALETTE_DEFAULT_HINTS }
